module.exports = __webpack_public_path__ + "img/am.de64212f.png";